<template>
  <section class="article-quote">
    <span class="article-quote__icon" />
    <blockquote class="article-quote__wrap" v-html="body" />
  </section>
</template>

<script>
export default {
  props: {
    body: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/components/_article-quote.scss';
</style>
